// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AutoDelivery: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.25 11.25">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M10.5 0a.75.75 0 0 0-.75.75v1.736A5.066 5.066 0 0 0 5.625.375a5.068 5.068 0 0 0-4.838 3.52.75.75 0 1 0 1.428.462 3.57 3.57 0 0 1 3.41-2.482c1.184 0 2.256.575 2.916 1.5H7.5a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 .75-.75V.75A.75.75 0 0 0 10.5 0Zm-.52 6.413a.75.75 0 0 0-.945.482 3.57 3.57 0 0 1-3.41 2.48 3.574 3.574 0 0 1-2.916-1.5H3.75a.75.75 0 1 0 0-1.5h-3a.75.75 0 0 0-.75.75V10.5a.75.75 0 1 0 1.5 0V8.764a5.068 5.068 0 0 0 8.941-1.409c.15-.394-.068-.837-.461-.942Z"
            />
        </svg>
    );
};

export default React.memo(AutoDelivery);
